import React from "react";
import { Link as RouterLink } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import MuiLink from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import HomeIcon from "@mui/icons-material/Home";

type ColorType =
  | string
  | "textPrimary"
  | "textSecondary"
  | "error"
  | "primary"
  | "secondary"
  | "info"
  | "success"
  | "warning"
  | "textDisabled";

interface IBreadcrumbItem {
  label: string;
  to?: string;
  icon?: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  underline?: "none" | "hover" | "always";
  color?: ColorType;
}

type BreadcrumbsMuiProps = {
  items: IBreadcrumbItem[];
  separator?: React.ReactNode;
  onHomeClick?: () => void;
  sx?: object;
};

const BreadcrumbsMui: React.FC<BreadcrumbsMuiProps> = ({
  items,
  separator = "/",
  onHomeClick,
  sx,
}) => (
  <Breadcrumbs aria-label="breadcrumb" separator={separator} sx={sx}>
    <MuiLink
      underline="hover"
      color="#00A1ED"
      component={RouterLink}
      to="/"
      onClick={onHomeClick}
    >
      <HomeIcon htmlColor="00A1ED" />
    </MuiLink>
    {items.map((item, index) => {
      const isLast = index === items.length - 1;
      if (isLast) {
        return (
          <Typography
            key={item.label}
            sx={{ color: "text.primary", fontSize: "0.875rem", lineHeight: 1 }}
          >
            {item.icon} {item.label}
          </Typography>
        );
      }
      return (
        <MuiLink
          key={item.label}
          underline={item.underline || "hover"}
          color={item.color || "#00A1ED"}
          component={RouterLink}
          to={item.to || "#"}
          onClick={item.onClick}
          sx={{ fontSize: "0.875rem" }}
        >
          {item.icon} {item.label}
        </MuiLink>
      );
    })}
  </Breadcrumbs>
);

export default BreadcrumbsMui;
